import clsx from 'clsx';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import {
  GraniteInput,
  GraniteInputProps,
} from 'components/V2/Input/GraniteInput';
import { useState } from 'react';
import { z } from 'zod';

interface AddEmailRecipientProps
  extends Pick<GraniteInputProps, 'label' | 'placeholder' | 'error'> {
  appendFunc: ({ email }: { email: string }) => void;
  buttonClassName?: string;
}

const AddEmailRecipient = ({
  appendFunc,
  label = 'Add another email recipient',
  placeholder = 'Type in email',
  buttonClassName = 'basis-[10%]',
  error,
}: AddEmailRecipientProps) => {
  const [newEmail, setNewEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);

  const validateEmail = (email: string) => {
    const isValid = !email || z.string().email().safeParse(email).success;
    setIsEmailValid(isValid);
    return isValid;
  };

  const handleAddEmail = () => {
    if (newEmail && validateEmail(newEmail)) {
      appendFunc({ email: newEmail });
      setNewEmail('');
    }
  };

  return (
    <div className="items-strech col-span-full flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-0">
      <GraniteInput
        label={label}
        error={(!isEmailValid && 'Invalid email') || error}
        placeholder={placeholder}
        className="flex-grow sm:basis-[90%]"
        innerInputClassName="sm:rounded-r-none"
        onChange={(e) => {
          setNewEmail(e.target.value);
          validateEmail(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            handleAddEmail();
          }
        }}
        value={newEmail}
      />
      <GraniteButton
        variant="secondary"
        className={clsx(
          `sm:rounded-l-none`,
          !isEmailValid || error ? 'mt-3' : 'mt-auto',
          buttonClassName,
          'sm:large',
        )}
        onClick={handleAddEmail}
      >
        Add
      </GraniteButton>
    </div>
  );
};

export default AddEmailRecipient;
